import { apiClient, type ApiClientResponse, routes } from 'common/services';

export const deleteFile = async (fileId: string) =>
  apiClient.delete<unknown, ApiClientResponse<unknown>>(routes.files.update(fileId));
